import { Media, mbSize } from '@foxrenderfarm/common/src/theme'
import styled from 'styled-components'

export const SelectWrapper = styled.div<{
  $width: number
  $height: number
  $mbWidth: number
  $mbHeight: number
  $fontSize: number
  $mbFontSize: number
  $borderColor: string
}>`
  position: relative;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  ${Media.lessThan(Media.small)} {
    font-size: ${({ $mbFontSize }) => mbSize($mbFontSize)};
    width: ${({ $mbWidth }) => mbSize($mbWidth)};
    height: ${({ $mbHeight }) => mbSize($mbHeight)};
  }
`

export const SelectInputWrapper = styled.div<{ $active: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 6px 10px;
  color: #666666;
  > input {
    font-family: MarkPro;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: inherit;
    border: none;
    outline: none;
    pointer-events: none;
  }
  > input::placeholder {
    color: #999999;
  }
  > svg.arrow {
    flex-shrink: 0;
    transition: all 0.3s;
    transform: rotate(${({ $active }) => ($active ? '180deg' : '0deg')});
  }
  ${Media.lessThan(Media.small)} {
    padding: ${mbSize(10)} ${mbSize(15)};
    > svg.arrow {
      width: ${mbSize(21)};
    }
  }
`

export const OptionWrapper = styled.div<{ $height?: number; $mbHeight?: number }>`
  width: 100%;
  height: ${({ $height }) => ($height ? `${$height}px` : 'fit-content')};
  max-height: ${({ $height }) => ($height ? `${$height}px` : '200px')};
  background: #f5f6fa;
  border-radius: 6px;
  box-shadow: 0px 20px 20px -10px #99999940;
  margin-top: 2px;
  border: 1px solid #f5f6fa;
  overflow: auto;
  z-index: 100;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(3)};
    height: ${({ $mbHeight }) => ($mbHeight ? `${$mbHeight}px` : 'fit-content')};
    max-height: ${({ $mbHeight }) => ($mbHeight ? `${$mbHeight}px` : '200px')};
  }
`

export const Option = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 10px;
  background: ${({ $isSelected }) => ($isSelected ? '#fff' : 'unset')};
  color: ${({ $isSelected }) => ($isSelected ? '#666666' : '#999999')};
  transition: all 0.3s;
  > span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &:hover {
    background: #fff;
    color: #666666;
  }
  ${Media.lessThan(Media.small)} {
    height: ${mbSize(60)};
    padding: 0 ${mbSize(15)};
  }
`
